import { Card, CardBody } from "reactstrap"
import { CanView } from "components/Common/CanView"
import { ACCESS } from "constants/accessPermissions"
import ActivityList from "./Activity/ActivityList"

export default function ActivityTab({ employee }) {
  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <CanView
          access={[
            ACCESS.EMPLOYEE.VIEW_ACTIVITY_LOG,
            ACCESS.ACTIVITY_LOG.VIEW_LIST,
          ]}
        >
          <ActivityList employee={employee} />
        </CanView>
      </CardBody>
    </Card>
  )
}
